import { useIntl } from 'react-intl';

/**
 * Hook to localize according to given message codes (wrapping Intl `intl.formatMessage` functionality)
 */
export default function useLocalizeMessage() {
  const intl = useIntl();
  return (messageCode: string) => intl.formatMessage({ id: messageCode });
};